<template>
	<div class="page container">
		<v2-back-btn />
		<div class="page__info">
			<div class="page__info--title">
				Notifications
			</div>
			<div class="page__info--subtitle">
				Bridge128 news and updates
			</div>
		</div>
		<div class="content">
			<div class="main">
				<div class="notifications-list">
					<template v-if="getShowList">
						<notification-preview
							v-for="notification in notifications"
							:key="notification.id"
							:notification="notification"
						/>
					</template>
					<div v-else-if="getShowEmptyState" class="list-empty-state">
						List is empty
					</div>
				</div>
				<pagination
					v-if="getShowPagination"
					v-bind="getPagination"
					@paginate="onPaginate"
				/>
			</div>
		</div>
	</div>
</template>

<script>

	import V2BackBtn from '@/components/v2/ui/V2BackBtn';
	import NotificationPreview from '@/components/notifications/NotificationPreview.vue';
	import Pagination from '@/components/ui/views/Pagination';
	import api from '@/services/api';

	const DEFAULT_LIMIT = 10;

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Notifications'
		},
		components: {
			NotificationPreview,
			Pagination,
			V2BackBtn
		},
		data () {
			return {
				isLoading: true,
				notifications: [],
				pagination: {
					page: 1,
					limit: DEFAULT_LIMIT,
					itemCount: 0,
					pageCount: 0,
					hasPreviousPage: false,
					hasNextPage: false
				}
			};
		},
		computed: {
			getBreadcrumbs () {
				return [
					{
						path: '/notifications',
						text: 'Notifications'
					}
				];
			},
			getPagination () {
				return {
					perPage: this.pagination.limit,
					currentPage: this.pagination.page,
					totalPages: this.pagination.pageCount
				};
			},
			getShowList () {
				return !this.isLoading && this.notifications?.length > 0;
			},
			getShowEmptyState () {
				return !this.isLoading && this.notifications?.length === 0;
			},
			getShowPagination () {
				return this.pagination.pageCount > 1;
			}
		},
		async created () {
			await this.fetchNotifications();
			this.$store.commit('ui/setLoadingIsHidden');
		},
		methods: {
			onPaginate (value) {
				this.pagination.page = value;
				this.fetchNotifications().catch(console.error);
			},
			async fetchNotifications () {
				const response = await api.notifications.getNotificationsList({
					limit: DEFAULT_LIMIT,
					page: this.pagination.page
				});
				if (!response) {
					this.isLoading = false;
					this.$store.commit('ui/showError');
					return false;
				}
				this.pagination = response.meta;
				this.notifications = response.data;
				this.isLoading = false;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
			}
		}
	};

</script>

<style lang="scss" scoped>

	.page__info {
		margin-bottom: 24px;
	}

	.content {
		.main {
			.notifications-list {
				display: grid;
				gap: 12px;
				margin-bottom: 20px;

				.list-empty-state {
					width: 100%;
					font-size: rem(18);
					color: $c-brand-grey;
					text-align: center;
				}
			}
		}

		@media (max-width: 1279px) {
			display: flex;
			flex-direction: column;

			.main {
				width: 100%;
			}
		}
	}

</style>
